import React, { useState, useEffect } from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import styled from "styled-components";
import {
  PrimaryButton,
  SecondaryButton,
  ButtonSizeOptions
} from "@loanbossinc/component-library";
import {
  FormControl,
  Select,
  MenuItem
} from "@material-ui/core";

import { CampaignType } from "./constants";

const Root = styled.div`
  font-family: Work Sans;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const Body = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  font-family: Work Sans;
  flex: 1;
  padding: 6px 0 30px 0;
`;

const TypeSelector = styled.div`
  display: flex;
  border-radius: 8px 8px 0 0;
  border: 1px solid #DADCE0;
`;

const Footer = styled.div`
  display: flex;
  justify-content: flex-end;
  font-family: Work Sans;
`;

const StyledMenuItem = styled(MenuItem)`&&& {
  font-family: 'Work Sans';
  height: 37px;
}`;

const StyledSelect = styled(Select)`
  font-family: 'Work Sans' !important;
  font-weight: 400;
  border-radius: 8px 8px 0 0;
  height: 50px;
  background-color: #F0F0F0;
  div {
    padding: 8px;
    background: rgba(0, 0, 0, 0) !important;
  }
`;

const StyledFormControl = styled(FormControl)`
  width: 100%;
`;

export const NewEmail = ({ onCancel: handleOnCancel, onCreate, campaignTypes }) => {
  const [campaigns, setCampaigns] = useState([]);
  const [selectedCampaign, setSelectedCampaign] = useState(0);

  useEffect(() => {
    // Temporarily filtering cash out, refi breakeven, and debt with us one off campaigns until needed. 2022/04/15
    const tempFilteredCampaignTypes = campaignTypes?.filter(({ id }) => id !== CampaignType.CASH_OUT_PROCEEDS.id &&
      id !== CampaignType.REFI_BREAKEVEN.id &&
      id !== CampaignType.DEBT_WITH_US.id);
    setCampaigns(tempFilteredCampaignTypes?.map(({ id, value }) => ({ id, value })));
  }, [campaignTypes]);

  const handleCreateCampaign = () => onCreate(selectedCampaign);

  return (
    <Root>
      <Body>
        <TypeSelector>
          {campaigns &&
            <StyledFormControl>
              <StyledSelect
                onChange={val => setSelectedCampaign(val.target.value)}
                value={selectedCampaign}
              >
                <StyledMenuItem value={0} disabled>Select a Campaign Type</StyledMenuItem>
                {campaigns.map((option, idx) => <StyledMenuItem
                  className="campaign-dropdown-menu-item"
                  key={`${option.value - idx}`}
                  value={option.value}
                >
                  {option.value}
                </StyledMenuItem>)}
              </StyledSelect>
            </StyledFormControl>}
        </TypeSelector>
      </Body>
      <Footer>
        <SecondaryButton
          label="Cancel"
          size={ButtonSizeOptions.smFluid}
          style={{ marginRight: 16, width: 132 }}
          onClick={handleOnCancel}
        />
        <PrimaryButton
          label="Create"
          disabled={!selectedCampaign}
          size={ButtonSizeOptions.smFluid}
          onClick={handleCreateCampaign}
          style={{ width: 132 }}
        />
      </Footer>
    </Root>
  );
};

const mapStateToProps = ({ configItems, emailCampaign }) => ({ configItems, ...emailCampaign });

export default compose(connect(mapStateToProps))(NewEmail);
